import React from "react";

import Logo from "../../../assets/images/alocentralmovil_logo.png";
import { useCreateAlocentralmovilContext } from "../create/provider/createAlocentralmovil.provider";
import { useCreateNewsAlocentralmovilContext } from "../create/news/provider/createNewsAlocentralmovil.provider";
import { useCreateUsedAlocentralmovilContext } from "../create/used/provider/createUsedAlocentralmovil.provider";
import { useLoginUser } from "../../../hooks/useLoginUser";

const Navbar = () => {
  const { setFlow, setStep, step } = useCreateAlocentralmovilContext();
  const { handleInitialState: handleInitialStateNews } =
    useCreateNewsAlocentralmovilContext();
  const { handleInitialState: handleInitialStateUsed } =
    useCreateUsedAlocentralmovilContext();
  const { logout } = useLoginUser();

  const handleLogout = () => {
    setFlow("new");
    handleInitialStateUsed();
    handleInitialStateNews();
    logout();
    setStep(1);
  };

  return (
    <nav className={`fixed z-40 w-full bg-white`}>
      <div className="max-w-screen flex px-32">
        <div className="ml-10 flex w-full items-center justify-between px-5 lg:px-0">
          <div className="-ml-7 mb-2 w-24 lg:ml-0 lg:w-52">
            <img
              alt="alocentralmovil_acinco_logo"
              src={Logo}
              className="img-fluid w-full"
            />
          </div>
          {step > 2 && (
            <div className="text-center">
              <button
                type="button"
                className="text-center"
                onClick={() => handleLogout()}
              >
                Cerrar sesión
              </button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};
export default Navbar;
